/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AnnualDeductible from './AnnualDeductible/index'
import CloseAction from './CloseAction/index'
import CoordinatedCoverage from './CoordinatedCoverage/index'
import Downpayment from './Downpayment/index'
import EffectiveFrom from './EffectiveFrom/index'
import EstimatedReimbursement from './EstimatedReimbursement/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import InNetworkDiscount from './InNetworkDiscount/index'
import InProgress from './InProgress/index'
import LossDueToAgeLimit from './LossDueToAgeLimit/index'
import LossDueToEffectiveDate from './LossDueToEffectiveDate/index'
import MaximumLifetimeCoverage from './MaximumLifetimeCoverage/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import PatientAgeLimit from './PatientAgeLimit/index'
import PreviouslyUsed from './PreviouslyUsed/index'
import React from 'react'
import ReimbursementDeductions from './ReimbursementDeductions/index'
import ReimbursementRate from './ReimbursementRate/index'
import RemainingAfterInsurance from './RemainingAfterInsurance/index'
import RemainingCoverage from './RemainingCoverage/index'
import SaveAction from './SaveAction/index'
import TotalDeductible from './TotalDeductible/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import Tysiav2InsuranceSubscription from 'DesignSystem/Svgs/Tysiav2InsuranceSubscription/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/CreateTreatmentPlan/EditTreatmentAndPaymentPlans/New/Steps/PaymentPlans/Content/PaymentPlan/Insurances/Insurance/EditAction/Content/Edit/Content"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let insuranceTextValueData = fromData.useDataValue({ viewPath,
context: 'insurance',
path: 'text',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 dangerouslyBypassFocusLock={true}
 maxHeight={700}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbc-4-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2InsuranceSubscription
  viewPath={`${viewPath}/Tysiav2InsuranceSubscription`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={dtColorsNeutral900}
 marginLeft={dtSpaceXs}
 data="insurance.text"
 text={insuranceTextValueData}
/>
</div>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-6-Z1Yf8zk': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-7-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bbc-4-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
>
<InNetworkDiscount
  viewPath={`${viewPath}/InNetworkDiscount`}
/>
<ReimbursementRate
  viewPath={`${viewPath}/ReimbursementRate`}
/>
<RemainingCoverage
  viewPath={`${viewPath}/RemainingCoverage`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<ReimbursementDeductions
  viewPath={`${viewPath}/ReimbursementDeductions`}
/>
<TotalDeductible
  viewPath={`${viewPath}/TotalDeductible`}
/>
<LossDueToAgeLimit
  viewPath={`${viewPath}/LossDueToAgeLimit`}
/>
<LossDueToEffectiveDate
  viewPath={`${viewPath}/LossDueToEffectiveDate`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<EstimatedReimbursement
  viewPath={`${viewPath}/EstimatedReimbursement`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<RemainingAfterInsurance
  viewPath={`${viewPath}/RemainingAfterInsurance`}
/>
</div>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--pt-7-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--blc-8-Z1Yf8zk': dtColorsNeutral200,'--pt-7-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<MaximumLifetimeCoverage
  viewPath={`${viewPath}/MaximumLifetimeCoverage`}
/>
<PreviouslyUsed
  viewPath={`${viewPath}/PreviouslyUsed`}
/>
<AnnualDeductible
  viewPath={`${viewPath}/AnnualDeductible`}
/>
<EffectiveFrom
  viewPath={`${viewPath}/EffectiveFrom`}
/>
<Downpayment
  viewPath={`${viewPath}/Downpayment`}
/>
<PatientAgeLimit
  viewPath={`${viewPath}/PatientAgeLimit`}
/>
<InProgress
  viewPath={`${viewPath}/InProgress`}
/>
<CoordinatedCoverage
  viewPath={`${viewPath}/CoordinatedCoverage`}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}